<div class="page-content page-fill">
  <div class="row flex-fill">
    <div class="col-4 flex-fill border-end">
      <div class="grid-fill">
        <dx-data-grid
          #groupGrid
          [dataSource]="groupStore"
          keyExpr="id"
          [focusedRowEnabled]="true"
          (focusedRowKeyChange)="onGroupSelectionChanged($event)"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          >
          <dxi-column dataField="name" caption="Group Name"></dxi-column>

          <div *dxTemplate="let data of 'toolbarButtons'">
            <dx-button text="Add" type="default" (onClick)="editGroup()"></dx-button>
            <dx-button
              text="Edit"
              type="normal"
              (onClick)="editGroup(groupGrid.focusedRowKey)"
              [disabled]="!groupGrid.focusedRowKey"
            ></dx-button>
            <!-- <dx-button text="Remove" type="normal" (onClick)="removeGroup()"></dx-button> -->
          </div>
          <div *dxTemplate="let data of 'toolbarText'">

          </div>
          <dxo-selection mode="none"></dxo-selection>
        </dx-data-grid>
      </div>
    </div>
    <div class="col-8 flex-fill">
      <div class="grid-fill">
        <dx-data-grid
          #groupPeopleGrid
          [dataSource]="people"
          [keyExpr]="'id'"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          [focusedRowEnabled]="false"
          noDataText="{{selectedGroupName==='Members' ? 'Automatically selects all members from database':'No data'}}"
          >
          <dxi-column dataField="person.firstName" caption="First Name" [sortIndex]="2" [sortOrder]="'asc'"></dxi-column>
          <dxi-column dataField="person.lastName" caption="Last Name" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
          <dxi-column dataField="person.email" caption="Email"></dxi-column>
          @if (appInfo.graafschap) {
            <dxi-column dataField="person.cellPhone" caption="Cell #"></dxi-column>
          }

          <dxo-paging [pageSize]="50"></dxo-paging>
          <dxo-selection mode="multiple"></dxo-selection>
          <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
          <dxo-search-panel [visible]="true"></dxo-search-panel>

          <div *dxTemplate="let data of 'toolbarButtons'">
            <dx-button text="Add" type="default" (onClick)="addToGroup()" [disabled]="!selectedGroupId || selectedGroupName==='Members' "></dx-button>
            <dx-button
              text="Remove"
              type="normal"
              (onClick)="removeFromGroup()"
              [disabled]="!(groupPeopleGrid.instance.getSelectedRowKeys().length > 0)"
            ></dx-button>
          </div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (people) {
              <span class="me-3">
                <strong>{{ groupPeopleGrid.instance.totalCount() + ' items' }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    </div>
  </div>
</div>

<dx-popup
  class="popup"
  [width]="400"
  [height]="'auto'"
  [showTitle]="true"
  [title]="(groupEdit?.id > 0 ? 'Edit' : 'New') + ' Group'"
  [hideOnOutsideClick]="true"
  (onHidden)="groupDialogHidden($event)"
  [(visible)]="groupDialogVisible"
  >
  <div *dxTemplate="let data of 'content'">
    <div class="dx-field">
      <div class="dx-field-label">Group Name</div>
      <div class="dx-field-value">
        <dx-text-box [(ngModel)]="groupEdit.name" [required]="true"></dx-text-box>
      </div>
    </div>
    <div class="text-end mt-3"><dx-button text="Save" type="default" (onClick)="saveGroup()"></dx-button></div>
  </div>
</dx-popup>

<dx-popup
  class="popup"
  [width]="700"
  [height]="600"
  [showTitle]="true"
  title="Add People to Group"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="popupVisible"
  >
  <div *dxTemplate="let data of 'content'">
    <dx-data-grid
      #unselectedPeopleGrid
      [dataSource]="dialogPeople"
      keyExpr="id"
      (onToolbarPreparing)="onDialogToolbarPreparing($event)"
      height="500"
      >
      <dxi-column dataField="firstName" [sortIndex]="2" [sortOrder]="'asc'"></dxi-column>
      <dxi-column dataField="lastName" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
      <dxi-column dataField="email"></dxi-column>
      @if (appInfo.graafschap) {
        <dxi-column dataField="cellPhone"></dxi-column>
      }

      <dxo-scrolling mode="virtual" showScrollbar="always" [preloadEnabled]="true"></dxo-scrolling>
      <dxo-paging [pageSize]="50"></dxo-paging>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-selection mode="multiple"></dxo-selection>
      <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>

      <div *dxTemplate="let data of 'dialogButtons'">
        <dx-button text="Add" type="default" (onClick)="addSelectedPeople()"></dx-button>
      </div>
    </dx-data-grid>
  </div>
</dx-popup>
